window.freeShippingBar = {

  init: () => {
    window.freeShippingBar.setFreeShippingInCart();
  },

  setFreeShippingInCart: (update) => {

    let cart_root = document.querySelector('.cart--root');
    if (
        cart_root && !cart_root.classList.contains('location_checked') || 
        cart_root && update == true
    ) {
      fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`, {
        method: 'GET'
      }).then(response => response.json()).then(response => {

        cart_root.classList.add('location_checked');
        let code = response.detected_values.country.handle.toLowerCase();

        if (code == 'pl' || code == 'gb') {

          let selected_countries = document.querySelector('.cart--root .selected_countries');
          if (selected_countries) {
            selected_countries.innerHTML = selected_countries.innerHTML.replace('[$]', response.detected_values.country_name);
            selected_countries.classList.add('is_active');
          }

          let bar = document.querySelector('.cart--root .cart--shipping-bar');
          if (bar) {
            bar.style.setProperty('--progress-percent', '100%');
            bar.closest('.cart--root').querySelector('.cart--shipping-message').classList.add('set_color');
          }
        } else {
          let total_products_value = window.freeShippingBar.checkProductsValue();
          let free_shipping_min_value = document.querySelector('.cart--root[data-free-shipping-min-value]') ? parseFloat(document.querySelector('.cart--root[data-free-shipping-min-value]').getAttribute('data-free-shipping-min-value')) : 'not_set';

          if (free_shipping_min_value != 'not_set') {
            free_shipping_min_value = parseFloat(free_shipping_min_value);
          }

          if (total_products_value > 0 && free_shipping_min_value != 'not_set') {
            let percent = (total_products_value / free_shipping_min_value) * 100;

            if (percent >= 100) {
              window.freeShippingBar.updateProgressBarValue(100);
            } else {
              window.freeShippingBar.updateProgressBarValue(percent.toFixed());
            }
          }
        }
      });
    }

  }, 

  checkProductsValue: () => {

    if (document.body.classList.contains('template--cart')) {
      var cart_items = document.querySelectorAll('.section--cart .cart--root:first-child .cart--item[data-base-price]');
    } else {
      var cart_items = document.querySelectorAll('.cart--root .cart--item[data-base-price]');
    }

    let cart_items_total_value = 0;

    if (cart_items.length) {
      cart_items.forEach((item) => {
        let item_qty = item.querySelector('.quantity-selector--input').value;
        let item_value = item.getAttribute('data-base-price');
        if (item_qty && item_value) {
          let item_total_value = parseFloat(item_value) * parseFloat(item_qty);
          cart_items_total_value = cart_items_total_value + item_total_value;
        }
      });
    }

    return cart_items_total_value;
  },

  updateProgressBarValue: (progress) => {
    let cart_root = document.querySelector('.cart--root');
    let bar = document.querySelector('.cart--root .cart--shipping-bar');
    let shipping_message = document.querySelector('.cart--shipping-message .other_countries .min_achieved');

    cart_root.setAttribute('data-free-shipping-progress', progress);
    shipping_message.closest('.cart--shipping-message').classList.add('set_color');

    if (shipping_message && progress == 100) {
      shipping_message.classList.add('is_active');
    }

    if (bar) {
      bar.style.setProperty('--progress-percent', `${progress}%`);
    }
  }

};

window.freeShippingBar.init();

(function () {
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    return originalFetch.apply(this, args).then(response => {
      const url = args[0];
      if (
        url.includes('/cart/add.js') ||
        url.includes('/cart/change.js') ||
        url.includes('/cart/update.js')
      ) {
        window.freeShippingBar.setFreeShippingInCart(true);
      };
      return response;
    });
  };
})();
